import React, { useState, useEffect, useRef, useContext } from 'react';
import styled from 'styled-components';
import { ReactComponent as SearchIcon } from '../../assets/search.svg';
import ConfigContext from '../../contexts/ConfigContext';
import { Input } from '../Input';
import { FlexColumn } from '../Flex';

const Root = styled(FlexColumn)`
  min-width: 280px;
  padding: 8px;
  gap: 8px;
`;

const UrlInputWrapper = styled.div`
  position: relative;

  input {
    border-radius: 4px;
    padding-right: 36px;
    min-height: 34px;
    height: 34px;

    &::placeholder {
      color: ${({ theme }) => theme.colors?.grey3 || '#676879'};
      font-weight: 400;
    }
  }
`;

const SearchIconWrapper = styled.span`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  pointer-events: none;
  color: ${({ theme }) => theme.colors?.grey4 || '#676879'};

  svg {
    width: 16px;
    height: 16px;
  }
`;

const DoneButton = styled.button`
  display: block;
  width: 100%;
  padding: 8px;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors?.primary || '#1890ff'};
  background: none;
  border: none;
  cursor: pointer;
  text-align: center;

  &:hover:not(:disabled) {
    opacity: 0.85;
  }

  &:disabled {
    color: ${({ theme }) => theme.colors?.grey3 || '#A7AEBC'};
    cursor: default;
  }
`;

const LinkMenu = ({ onDone, onClose, initialUrl = '' }) => {
  const [url, setUrl] = useState(initialUrl);
  const inputRef = useRef(null);
  const trimmedUrl = url.trim();
  const { t } = useContext(ConfigContext);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleDone = () => {
    if (!trimmedUrl) return;
    onDone({ url: trimmedUrl });
  };

  return (
    <Root>
      <UrlInputWrapper>
        <Input
          inputRef={inputRef}
          type="url"
          placeholder="https://example.com"
          value={url}
          onChange={setUrl}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleDone();
            }
            if (e.key === 'Escape') onClose();
          }}
        />
        <SearchIconWrapper>
          <SearchIcon />
        </SearchIconWrapper>
      </UrlInputWrapper>

      <DoneButton type="button" onClick={handleDone} disabled={!trimmedUrl}>
        {t('done')}
      </DoneButton>
    </Root>
  );
};

export default LinkMenu;
